export default {
  Loading: 'Cargando...',
  search: 'Buscar...',
  noMessages: 'Ningún mensaje',
  noSearchResults: 'No se encontraron registros que coincidan',
};
